import React from 'react';
import { BookOpen } from 'lucide-react';
import CodeExamplesContent from './CodeExamplesContent';
import PageHeader from './PageHeader';
import './DocsPage.css';

const DocsPage: React.FC = () => {
  const apiKey = 'YOUR_API_KEY';

  return (
    <div className="docs-page">
      <PageHeader
        icon={BookOpen}
        title="Documentation"
        subtitle="Complete guide to the Moderation Platform and API products"
      />

      <CodeExamplesContent apiKey={apiKey} showDocumentation={true} />
    </div>
  );
};

export default DocsPage;